module.exports = __webpack_public_path__ + "static/img/9.9fc72c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/list/9.png
// module id = IJgY
// module chunks = 1